import { Routes } from '@angular/router';
import { authenticatedRouteGuards, canActivateUser } from '@shared/guard/guard';
import { canActivatePlayground } from '@shared/guard/playground.guard';
import { PageKey } from '@shared/services/page/models/page.key';

export const playgroundRoute: Routes = [
  {
    path: 'playground',
    loadComponent: () => import('./pages/playground/playground.component').then(m => m.PlaygroundComponent),
    canActivate: [...authenticatedRouteGuards, canActivateUser, canActivatePlayground],
    data: {
      title: 'Playground',
      key: PageKey.PLAYGROUND
    }
  }
];
